import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    gradeApplication: null,
    grades: [],
    selectedGrade: null,
    selectedGradeName: "",
}

const gradeApplicationSlice = createSlice({
    name: 'gradeApplication',
    initialState,
    reducers: {
        setGradeApplication(state, action) {
            state.gradeApplication = action.payload;
        },
        setGrades(state, action) {
            state.grades = action.payload;
        },
        setSelectedGrade(state, action) {
            state.selectedGrade = action.payload;
        },
        setSelectedGradeName(state, action) {
            state.selectedGradeName = action.payload;
        },
    }
});

export const { setGradeApplication, setGrades, setSelectedGrade,setSelectedGradeName } = gradeApplicationSlice.actions;

export default gradeApplicationSlice.reducer;
